<dx-scroll-view direction="both" width="100%" height="100%" [scrollByContent]="true" [scrollByThumb]="true">
    <dx-box height="100%" width="95%" direction="col">
        <dxi-item baseSize="auto">
            <div class="submit-a-ticket-container">
                <div>
                    <h1>
                        <strong class="dx-theme-accent-as-text-color">
                            Submit a ticket to the CiraNet Support Team
                        </strong>
                    </h1>
                    <p class="cc-1-5x">
                        What kind of issue are you having? Choose from the categories below.
                        <br />
                        <span>
                            Submitting the right ticket type helps us resolve your issue quickly and efficiently.
                        </span>
                    </p>
                    <div class="ticket-help-message cc-1-5x">
                        Don't see a ticket type that matches your need?
                        <span (click)="isTicketHelpModalVisible = true">
                            <strong class="dx-theme-accent-as-text-color">Click here</strong>
                        </span>

                        to learn why and what to do next.
                    </div>
                </div>
                <div>
                    <div class="dx-theme-accent-as-text-color view-tickets" (click)="viewOpenTickets()">
                        <i class="fas fa-list fs-40"></i>
                        <span class="cc-1rx">View Your Open Tickets</span>
                    </div>
                </div>
            </div>
            <hr class="dx-theme-accent-as-text-color hr-view" />
        </dxi-item>
        <dxi-item [ratio]="1">
            <div>
                <div>
                    <h1>
                        <strong class="dx-theme-accent-as-text-color">
                            CiraNet Portals / CiraMail / CiraMobile / CiraBudget
                        </strong>
                    </h1>
                    <dx-box height="100%" width="100%" direction="row">
                        <dxi-item [ratio]="1">
                            <div *dxTemplate>
                                <span class="cc-text-bold fs-25">General</span>
                                <div class="d-flex add-spacing">
                                    <ng-container
                                        [ngTemplateOutlet]="contactUsTile"
                                        [ngTemplateOutletContext]="{
                                            data: {
                                                id: 'technicalIssueId',
                                                icon: 'fas fa-laptop-code',
                                                iconClass: 'cc-icon-aqua fs-40',
                                                htmlText: 'Technical Issue',
                                                targetUrl: 'TI'
                                            }
                                        }"
                                    ></ng-container>
                                    <ng-container
                                        [ngTemplateOutlet]="contactUsTile"
                                        [ngTemplateOutletContext]="{
                                            data: {
                                                id: 'accessIssueId',
                                                icon: 'fas fa-user-lock',
                                                iconClass: 'cc-icon-aqua fs-40',
                                                htmlText: 'Access Issue',
                                                targetUrl: 'AI'
                                            }
                                        }"
                                    ></ng-container>
                                </div>
                                <span class="cc-text-bold fs-25 top-padding">Setup</span>
                                <div class="d-flex add-spacing">
                                    <ng-container
                                        [ngTemplateOutlet]="contactUsTile"
                                        [ngTemplateOutletContext]="{
                                            data: {
                                                id: 'templateIssueId',
                                                icon: 'fas fa-file-alt',
                                                iconClass: 'cc-icon-aqua fs-40',
                                                htmlText: 'Template',
                                                targetUrl: 'T'
                                            }
                                        }"
                                    ></ng-container>
                                    <ng-container
                                        [ngTemplateOutlet]="contactUsTile"
                                        [ngTemplateOutletContext]="{
                                            data: {
                                                id: 'configurationIssueId',
                                                icon: 'fas fa-tools',
                                                iconClass: 'cc-icon-aqua fs-40',
                                                htmlText: 'Configuration',
                                                targetUrl: 'C'
                                            }
                                        }"
                                    ></ng-container>
                                </div>
                                <h1>
                                    <strong class="dx-theme-accent-as-text-color">General Technology Support</strong>
                                </h1>
                                <div>
                                    <ul class="cc-1rx">
                                        <li>Desktop or laptop issues</li>
                                        <li>Issues with accessories (mouse, keyboard, headset)</li>
                                        <li>Network or connectivity</li>
                                        <li>Problems with software or other hardware</li>
                                    </ul>
                                </div>
                                <span class="cc-1rx">
                                    Contact your local technology or infrastructure support team.
                                </span>
                            </div>
                        </dxi-item>
                        <dxi-item [ratio]="1">
                            <div *dxTemplate>
                                <div class="d-flex align-content">
                                    <div class="contact-us-tile cc-hyperlink tips-container cc-card-box-shadow">
                                        <div class="tips-header">
                                            <span>
                                                <i
                                                    class="fas fa-star dx-theme-accent-as-text-color"
                                                    [ngClass]="iconStar"
                                                ></i>
                                            </span>
                                            <h3>
                                                <strong class="dx-theme-accent-as-text-color">
                                                    Tips for faster support
                                                </strong>
                                            </h3>
                                        </div>
                                        <p class="cc-1rx">
                                            Follow these simple tips to help us resolve your issue as efficiently and
                                            accurately as possible.
                                        </p>
                                        <div class="d-flex">
                                            <div class="tips-info">
                                                <div>
                                                    <p class="dx-theme-accent-as-text-color cc-text-bold cc-1rx">
                                                        Be Clear & Concise
                                                    </p>
                                                    <span class="cc-1rx">
                                                        Use complete sentences and avoid unnecessary jargon.
                                                    </span>
                                                </div>
                                                <div>
                                                    <p class="dx-theme-accent-as-text-color cc-text-bold cc-1rx">
                                                        Provide Screenshots
                                                    </p>
                                                    <span class="cc-1rx">Include your full desktop when possible.</span>
                                                </div>
                                                <div>
                                                    <p class="dx-theme-accent-as-text-color cc-text-bold cc-1rx">
                                                        Note Impact & Urgency
                                                    </p>
                                                    <span class="cc-1rx">
                                                        If this is blocking your work, indicate how urgent it is.
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="tips-info">
                                                <div>
                                                    <p class="dx-theme-accent-as-text-color cc-text-bold cc-1rx">
                                                        Include Key Details
                                                    </p>
                                                    <span class="cc-1rx">
                                                        Tell us exactly what you were doing, including browser/OS info.
                                                    </span>
                                                </div>
                                                <div>
                                                    <p class="dx-theme-accent-as-text-color cc-text-bold cc-1rx">
                                                        Share Recent Changes
                                                    </p>
                                                    <span class="cc-1rx">
                                                        Mention any recent system or software updates.
                                                    </span>
                                                </div>
                                                <div>
                                                    <p class="dx-theme-accent-as-text-color cc-text-bold cc-1rx">
                                                        Follow Up Promptly
                                                    </p>
                                                    <span class="cc-1rx">
                                                        Keep track of your ticket and follow up if needed.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </dxi-item>
                    </dx-box>
                </div>
            </div>
        </dxi-item>
    </dx-box>
</dx-scroll-view>

<ng-template #contactUsTile let-data="data">
    <div
        *ngIf="data.htmlText"
        [id]="data.id"
        class="general-setup-content dx-theme-accent-as-background-color dx-theme-accent-as-border-color"
        [ngClass]="{
            'contact-us-tile cc-hyperlink': !!data.targetUrl
        }"
        (click)="onTileClick(data.targetUrl)"
        (mouseenter)="onTileHover(data.id, true)"
        (mouseleave)="onTileHover(data.id, false)"
    >
        <i [ngClass]="data.icon" class="{{ data.iconClass }}"></i>
        <div class="text-content dx-theme-background-color-as-text-color">
            <span class="cc-1rx">{{ data.htmlText }}</span>
        </div>
    </div>
</ng-template>

<dx-popover [target]="'#' + activePopoverTarget" position="top" showEvent="mouseenter" [(visible)]="isPopoverVisible">
    <div *dxTemplate="let data of 'content'" class="popover-content">
        <h4>
            <strong class="cc-1rx">{{ activePopoverData.title }}</strong>
        </h4>
        <p>{{ activePopoverData.description }}</p>
        <ul>
            <li *ngFor="let item of activePopoverData.items">{{ item }}</li>
        </ul>
    </div>
</dx-popover>

<dx-popup
    width="45%"
    height="50%"
    titleTemplate="title"
    [showTitle]="true"
    [resizeEnabled]="true"
    [showCloseButton]="true"
    [visible]="isTicketHelpModalVisible"
    (onShown)="onShown($event)"
    (onHidden)="isTicketHelpModalVisible = false"
>
    <div *dxTemplate="let data of 'title'">
        <dx-toolbar>
            <dxi-item location="before">
                <h3 class="popup-header">
                    <strong class="dx-theme-accent-as-text-color">
                        Why don't I see a ticket type that matches my request?
                    </strong>
                </h3>
            </dxi-item>
            <dxi-item location="after">
                <div (click)="isTicketHelpModalVisible = false" class="cc-1rx close-popup">
                    <i [ngClass]="iconCancel"></i>
                </div>
            </dxi-item>
        </dx-toolbar>
    </div>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div class="cc-1rx">
                    <p>
                        We've streamlined our ticket types to make it easier and faster for you to submit requests.
                        Here's why you may not see a specific option:
                    </p>
                    <ul>
                        <li>
                            <strong>Fewer Forms, Smarter Routing</strong>
                            - Many previous sub-categories are now built into one form using conditional logic, so
                            select the most relevant category and answer the questions.
                        </li>
                        <br />
                        <li>
                            <strong>Feature Requests Are No Longer Submitted Here</strong>
                            - For new ideas or system enhancements, collaborate with your team and leadership to define
                            and prioritize the request before proposing it.
                        </li>
                        <br />
                        <li>
                            <strong>Some Requests Are Out of Scope</strong>
                            - Our team focuses on specific services. Check with your supervisor for the correct process
                            if your request falls outside our scope.
                        </li>
                        <br />
                    </ul>
                    <p>
                        Still unsure where to go? Reach out to your supervisor or internal support contacts for
                        guidance.
                    </p>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconCancel"
                                    (onClick)="isTicketHelpModalVisible = false"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
